import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const heroImage = "https://images.unsplash.com/photo-1758195437166-a95e62c0590f?w=1920&q=75&fm=webp&fit=crop";

export const Hero = () => {
  const scrollToAbout = () => {
    const aboutSection = document.querySelector('#about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden">

      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Hemraj Grandsons Architecture"
          className="w-full h-full object-cover" />

        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6 lg:px-12">
        <motion.p
          className="overline mb-6 !text-[#E7E7E7]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}>


        </motion.p>

        <motion.h1
          data-testid="hero-title"
          className="font-heading text-4xl sm:text-5xl lg:text-7xl xl:text-8xl font-light text-[#F9F6F0] tracking-tight max-w-5xl leading-[1.1]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}>

          Building the Environments Where Life Happens
        </motion.h1>

        <motion.p
          data-testid="hero-subtitle"
          className="max-w-2xl !font-medium mt-8 !rounded-lg text-[#F9F6F0]/80"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}>

          A vertically integrated Indian group of companies creating a connected 
          ecosystem across real estate, design, hospitality, technology, fashion, and culture.
        </motion.p>

        <motion.div
          className="mt-12 flex flex-col sm:flex-row gap-4"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}>

          <button
            data-testid="hero-cta-explore"
            onClick={scrollToAbout}
            className="btn-primary bg-[#F9F6F0] text-[#1A1A1A] hover:bg-[#C5A880]">

            Explore Our World
          </button>
          <button
            data-testid="hero-cta-contact"
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-outline border-[#F9F6F0] hover:bg-[#F9F6F0] hover:text-[#1A1A1A] text-[#F9F6F0] !bg-[#FFA200]">

            Get in Touch
          </button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.button
        data-testid="scroll-indicator"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#F9F6F0]/60 hover:text-[#F9F6F0] transition-colors"
        onClick={scrollToAbout}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{
          opacity: { duration: 0.5, delay: 1 },
          y: { duration: 2, repeat: Infinity, ease: "easeInOut" }
        }}>

        <ChevronDown size={32} />
      </motion.button>
    </section>);

};